import { DisplayMoney } from '@tock/money';
import { IconCreditCard } from '@tocktix/pantry';
import { Theme, css } from '@emotion/react';
import { Typography, TypographyProps } from 'bento';
import { core } from '@tock/coretypes';
import React from 'react';

type PaymentCardHoldStatus = core.PaymentCardHold['status'];

const DESCRIPTIONS: Record<PaymentCardHoldStatus, string> = {
  HOLD_CHARGED: 'charged',
  HOLD_PENDING: 'ready to charge',
  HOLD_REFUNDED: 'refunded',
};

const COLORS: Record<PaymentCardHoldStatus, TypographyProps['color']> = {
  HOLD_CHARGED: 'subtle',
  HOLD_PENDING: 'dangerBase',
  HOLD_REFUNDED: 'subtle',
};

interface Props {
  paymentCardHold: core.IPaymentCardHold | null | undefined;
  isEligibleForCharge: boolean;
  isEligibleForRefund: boolean;
  statusesToDisplay?: PaymentCardHoldStatus[];
}

export const DisplayBookingFee: React.FC<Props> = ({
  paymentCardHold,
  isEligibleForCharge,
  isEligibleForRefund,
  statusesToDisplay,
}) => {
  const status = paymentCardHold?.status;
  const bookingPolicyFeeAmount = paymentCardHold?.amountCents ?? 0;
  if (
    !status ||
    (statusesToDisplay && !statusesToDisplay.includes(status)) ||
    (!isEligibleForCharge && !isEligibleForRefund && status !== 'HOLD_REFUNDED') ||
    bookingPolicyFeeAmount === 0
  ) {
    return null;
  }

  return (
    <Typography
      color={COLORS[status]}
      css={css`
        align-items: center;
        display: flex;
      `}
    >
      <IconCreditCard
        css={(theme: Theme) => css`
          height: 16px;
          width: 16px;
          margin-right: ${theme.spacing(0.5)}px;
        `}
      />
      <DisplayMoney amount={bookingPolicyFeeAmount} digitsToDisplay={2} roundIfWholeNumber />,{' '}
      {DESCRIPTIONS[status]}
    </Typography>
  );
};
